import { combineReducers } from 'redux';
import { HYDRATE } from 'next-redux-wrapper';

import metaData from '~/containers/MetaDataProvider/reducer';
import authData from '~/containers/AuthProvider/reducer';
import loader from '~/containers/Loader/reducer';
import categoryPage from '~/containers/CategoryPageContainer/reducer';
import templatePage from '~/containers/TemplatePageContainer/reducer';
import homePage from '~/containers/HomePageContainer/reducer';
import templatePreviewContainer from '~/containers/TemplatePreviewContainer/reducer';
import demoHomePage from '~/containers/DemoHomePageContainer/redux/reducer';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    metaData,
    authData,
    loader,
    categoryPage,
    templatePage,
    homePage,
    templatePreviewContainer,
    demoHomePage,
    ...injectedReducers,
  });

  const rootReducerWithHydrate = (state, action) => {
    switch (action.type) {
      case HYDRATE:
        return { ...state, ...action.payload };

      default: {
        return rootReducer(state, action);
      }
    }
  };

  return rootReducerWithHydrate;
}
